import { injectable } from 'inversify'

const facebookClientId = '186456532012398'

export interface IConfig {
  getApiUrl (): string
  getFacebookClientId (): string
  getFacebookRedirectUri (): string
}

@injectable()
export class Config {
  public getApiUrl (): string { return process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'error' }
  public getFacebookClientId (): string { return process.env.VUE_APP_FACEBOOKCLIENTID ? process.env.VUE_APP_FACEBOOKCLIENTID : 'error' }
  public getFacebookRedirectUri (): string { return process.env.VUE_APP_FACEBOOKREDIRECT ? process.env.VUE_APP_FACEBOOKREDIRECT : 'error' }
}
